import React, { memo, useMemo } from 'react';
import { Modal } from 'antd';
import cn from 'classnames';
import {
  useCropperModalActions,
  useCropperModalState,
} from '../../features/cropperModal';
import UploadBlock from '../UploadBlock/UploadBlock';
import { modalModes } from '../../model';
import ErrorsBlock from '../ErrorsBlock/ErrorsBlock';
import ErrorFooter from './components/ErrorFooter/ErrorFooter';
import CropperBlock from '../CropperBlock/CropperBlock';
import CropperFooter from './components/CropperFooter/CropperFooter';
import styles from './CropperModal.module.scss';

const getDisplayComponents = (mode) => {
  switch (mode) {
    case modalModes.initial:
      return {
        title: 'Добавление обложки',
        content: <UploadBlock />,
        footer: null,
      };

    case modalModes.cropper:
      return {
        title: 'Редактирование обложки',
        content: <CropperBlock />,
        footer: <CropperFooter />,
      };

    case modalModes.error:
      return {
        title: 'Ошибка',
        content: <ErrorsBlock />,
        footer: <ErrorFooter />,
      };
  }
};

const CropperModal = () => {
  const { visible, mode, confirmLoading } = useCropperModalState();
  const { onCancel, afterClose } = useCropperModalActions();

  const { title, content, footer } = useMemo(
    () => getDisplayComponents(mode) || {},
    [mode]
  );

  return (
    <Modal
      visible={visible}
      title={title}
      footer={footer}
      onCancel={onCancel}
      confirmLoading={confirmLoading}
      afterClose={afterClose}
      width=""
      className={cn(styles.root, {
        [styles.cropper]: mode === modalModes.cropper,
      })}
      transitionName="fade"
    >
      {content}
    </Modal>
  );
};

export default memo(CropperModal);
